import React, {ReactElement} from 'react';
import DynamicLink from '../../DynamicLink/DynamicLink';
import {ALL_TAG} from './constants';

import './TagsButtons.scss';

export interface TagProps {
  label: string;
  tag: string;
  url: string;
}

export interface TagsButtonsProps {
  tags: TagProps[];
  selectedTag?: string;
}

const isSelected = (entry: TagProps, selectedTag?: string) => {
  if (selectedTag === entry.tag) {
    return true;
  }

  if (!selectedTag && entry.tag === ALL_TAG) {
    return true;
  }

  return false;
};

function TagsButtons({tags, selectedTag}: TagsButtonsProps): ReactElement {
  return (
    <div className="tagsButtons">
      {tags.map((entry) => (
        <div className="tagsButtons__buttonContainer" key={entry.label}>
          <DynamicLink
            className={`tagsButtons__buttonContainer__button unstyledLink ${
              isSelected(entry, selectedTag) ? 'active' : ''
            }`.trim()}
            data-testid={`control.tagButton.${entry.tag}`}
            href={entry.url}
          >
            {entry.label}
          </DynamicLink>
        </div>
      ))}
    </div>
  );
}

export default TagsButtons;
